<template>
  <common-dialog class="refund-dialog" :show.sync="visible" title="选择退保人员" :show-footer="false">
    <div class="refund-insurance-body" v-if="visible">
      <div class="tips-box">
        <div class="tips">
          <img class="icon" src="../../assets/imgs/user-insurance/icon-tips-blue.png" alt="">
          请选择需要退保的人员，将由系统审核后退保
        </div>
      </div>
      <div class="applicant-list">
        <div class="applicant-item" @click="handleSelectApplicant(applicant)" v-for="applicant in applicantList" :key="applicant.order_applicant_id">
          <img class="item-avatar" :src="(applicant.id_photo && applicant.id_photo.dest_photo && applicant.id_photo.dest_photo.indexOf('elec_material_by_offline.jpg') === -1) ? applicant.id_photo.dest_photo : 'https://o.666visa.cn/static/ssqwxa/historical-applicant/applicant-default-2x.png'" />
          <div class="item-info">
            <div class="top">
              <div class="applicant-name">{{applicant.applicant_name}}</div>
              <div class="identity">{{applicant.identity}}</div>
            </div>
            <div class="bottom">护照号码：{{passportHandle(applicant.applicant_passport.passport_number)}}</div>
          </div>
          <div class="item-select-box">
            <img v-if="!applicant.checked" class="checkbox-img" src="https://o.666visa.cn/static/ssqwxa/order-confirm/icon-checkbox.png" />
            <img v-else class="checkbox-img" src="https://o.666visa.cn/static/ssqwxa/order-confirm/icon-checkbox-active.png" />
          </div>
        </div>
      </div>
      <div class="footer">
        <button @click="handleSelectAll" class="s-btn btn-blue is-plain">{{popIsSelectAll ? '取消全选' : '全选'}}</button>
        <button @click="submit" class="s-btn btn-blue">确认退保（{{popCurrSelectApplicant.length}}人）</button>
      </div>
    </div>
  </common-dialog>
</template>
<script>
import commonDialog from '../common/modals/common-dialog/common-dialog';
import Http from '../../libs/http.js';

export default {
  name: '',
  components: {
    commonDialog,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
    },
  },
  data() {
    return {
      visible: this.value,
      applicantList: [],
    };
  },
  computed: {
    // 弹窗内勾选的申请人
    popCurrSelectApplicant() {
      if (!this.order) return [];
      return this.applicantList.filter(item => item.checked);
    },
    // 是否选择了所有申请人
    popIsSelectAll() {
      if (!this.order) return false;
      return this.applicantList.every(item => item.checked);
    },
  },
  watch: {
    visible(newValue) {
      this.$emit('input', newValue);
    },
    value(val) {
      this.visible = val;
      if (val) {
        this.init();
      }
    },
  },
  created() {
    if (this.visible) {
      this.init();
    }
  },
  methods: {
    init() {
      // 抽取所有可以退款的申请人
      const applicantList = JSON.parse(JSON.stringify(this.order.applicant.filter(item => item.applicant_insurance && item.applicant_insurance.status === 1)));
      applicantList.forEach((item) => {
        item.checked = true;
      });
      this.applicantList = applicantList;
    },
    passportHandle(string) {
      if (string && string.length > 3) {
        const middle = Math.floor(string.length / 2);
        string = `${string.substring(0, middle - 1)}***${string.substring(middle + 2)}`;
      }
      return string;
    },
    handleSelectApplicant(item) {
      item.checked = !item.checked;
    },
    handleSelectAll() {
      const checked = !this.popIsSelectAll;
      this.applicantList.forEach(item => item.checked = checked);
    },
    submit() {
      if (this.popCurrSelectApplicant.length === 0) {
        this.$message({
          message: '请至少选择一个退保人员',
          type: 'warning',
        });
        return;
      }
      Http.post('/insurance_cancel', {
        order_id: this.order.user_order_id,
        applicant_id_set: this.popCurrSelectApplicant.map(item => item.order_applicant_id),
      }).then(() => {
        this.$message({
          message: '提交成功，退保成功将退款至账户余额',
          type: 'success',
        });
        this.visible = false;
        this.$emit('on-success');
      });

    },
  },
};
</script>
<style lang="less" scoped>
.refund-dialog{
  /deep/ .el-dialog{
    background: #FAFBFC;
    width: 580px;
  }
}
.refund-insurance-body{
  padding: 0 24px 0 24px;
  position: relative;
  line-height: 1;
  .tips-box{
    padding: 10px 0;
    background: #FAFBFC;
    .tips{
      background:rgba(89,159,255,0.04);
      display: flex;
      align-items: center;
      height: 32px;
      padding: 0 12px;
      color: #599FFF;
      font-size: 14px;
      .icon{
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
    }
  }
  .applicant-list{
    padding: 12px 0;
    max-height: calc(~'80vh - 132px');
    overflow: auto;
    // 定义滚动条宽高及背景
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #ffffff;
    }

    /*定义滚动条轨道*/
    &::-webkit-scrollbar-track {
      border-radius: 2px;
    }

    // 定义滚动条滑块
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0,0,0,0.2);
      border-radius: 2px;

      &:hover {
        background-color: rgba(0,0,0,0.3);
      }
    }
    .applicant-item{
      cursor: pointer;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      padding: 12px 16px;
      background: #fff;
      box-shadow:0px 2px 8px -4px rgba(47,51,61,0.12);
      border-radius: 4px;
      &:last-child{
        margin-bottom: 0;
      }
      .item-avatar{
        flex-shrink: 0;
        width: 34px;
        height: 44px;
        margin-right: 12px;
      }
      .item-info{
        flex-grow: 1;
        overflow: hidden;
        .top{
          display: flex;
          align-items: center;
          .applicant-name{
            color: #2F333D;
            font-size: 15px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .identity{
            background:rgba(95,102,110,0.08);
            height: 16px;
            padding: 0 4px;
            border-radius:1px;
            display: flex;
            align-items: center;
            color: #5F666E;
            font-size: 12px;
            margin-left: 6px;
            flex-shrink: 0;
          }
        }
        .bottom{
          margin-top: 12px;
          color: #5F666E;
          font-size: 12px;
        }
      }
      .item-select-box{
        flex-shrink: 0;
        margin-left: 12px;
        .checkbox-img{
          width: 14px;
          height: 14px;
        }
      }

    }
  }
  .footer{
    background: #FAFBFC;
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .s-btn{
      padding: 0 30px;
      height: 40px;
      min-width: 126px;
    }
    .s-btn + .s-btn{
      margin-left: 10px;
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/components/insurance/refund-insurance-dialog.vue